module.exports = __webpack_public_path__ + "img/ro.ba283802.svg";